import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { ConfigurationService } from '../services/configuration.service';
//TODO: check if use jwt or other
//import { tokenNotExpired } from 'angular2-jwt';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthService {

  idToken: string;
  // user: any;

  constructor(
    private http: Http,
    public configurationService: ConfigurationService
  ) {
    this.idToken = localStorage.getItem('id_token');
    // this.user = JSON.parse(localStorage.getItem('user'));
  }

  public login(user:string, password:string): Observable<Response> {
    const url = `${ environment.apiRoot }/login/`;
    const body = JSON.stringify({ user: user, password:password });

    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(url, body, { headers: headers })
      .map((response: Response) => response.json())
      .do((json: any) => this.saveToken(json))
      .catch((error:any) => Observable.throw(error.json().meta && error.json().meta.message || 'Parece que hay problemas con la red o con tu conexión de internet'));
  }

  public loginToken(token:string): Observable<Response> {
    const url = `${ environment.apiRoot }/login/`;
    const body = JSON.stringify({ token: token });

    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(url, body, { headers: headers })
      .map((response: Response) => response.json())
      .do((json: any) => this.saveToken(json))
      .catch((error:any) => Observable.throw(error.json().meta && error.json().meta.message || 'Parece que hay problemas con la red o con tu conexión de internet'));
  }

  public authenticated() {
    return this.idToken !== null;
    //TODO: check if token has expired
    //return tokenNotExpired('id_token', this.idToken);
  }

  //noinspection JSMethodCanBeStatic
  private saveToken(res) {
    if(res && res.meta) {
      if(res.meta.status === 200) {
        this.idToken = res.data.id_token;
        this.configurationService.changeConfiguration(res.data);
      }
    }
  }

  //noinspection JSMethodCanBeStatic
  public logout(): void {
    localStorage.clear();
    this.idToken = null;
    // this.user = null;
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/auth.service.ts